var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{attrs:{"content-class":"mt-3"}},[(
      _vm.action.channel == 'email' ||
      _vm.action.channel == 'email/whatsapp' ||
      _vm.action.channel == 'qrcode' ||
      _vm.action.channel == 'emailsms' ||
      _vm.action.channel == 'widget' ||
      _vm.action.channel == 'link' ||
      _vm.action.channel == 'totem' ||
      _vm.action.channel == 'whatsapp' ||
      (_vm.action.channel == 'sms' && _vm.action.sms.config === 'link') ||
      _vm.action.channel == 'click-to-call'
    )?_c('b-tab',{attrs:{"title":("" + (this.$t('newAction.stepOne.surveyLayout'))),"active":""}},[_c('template-email')],1):_vm._e(),_vm._v(" "),(
      (_vm.action.channel == 'email' ||
        _vm.action.channel == 'emailsms' ||
        _vm.action.channel == 'widget' ||
        _vm.action.channel == 'qrcode' ||
        _vm.action.channel == 'link' ||
        _vm.action.channel == 'totem' ||
        _vm.action.channel == 'click-to-call' ||
        _vm.action.channel == 'whatsapp' ||
        (_vm.action.channel == 'sms' && _vm.action.sms.config === 'link')) &&
      _vm.action.closingMessageEnabled
    )?_c('b-tab',{attrs:{"title":("" + (this.$t('newAction.stepOne.titleClosingMessage')))}},[_c('template-closing-message')],1):_vm._e(),_vm._v(" "),(
      (_vm.action.channel == 'email' ||
        _vm.action.channel == 'emailsms') &&
      _vm.action.enableCustomTemplateEmail
    )?_c('b-tab',{attrs:{"title":"Carta convite"}},[_c('template-email-custom')],1):_vm._e(),_vm._v(" "),(
      (_vm.action.channel == 'email' ||
        _vm.action.channel == 'emailsms' ||
        _vm.action.channel == 'widget' ||
        _vm.action.channel == 'qrcode' ||
        _vm.action.channel == 'link' ||
        _vm.action.channel == 'totem' ||
        _vm.action.channel == 'click-to-call' ||
        (_vm.action.channel == 'sms' && _vm.action.sms.config === 'link')) &&
      _vm.action.automaticAnswerEnabled
    )?_c('b-tab',{attrs:{"title":("" + (this.$t('newAction.stepOne.titleAutomaticAnswer')))}},[_c('template-automatic-answer')],1):_vm._e(),_vm._v(" "),(_vm.action.channel == 'sms' || _vm.action.channel == 'emailsms')?_c('b-tab',{attrs:{"title":"SMS"}},[_c('template-sms')],1):_vm._e(),_vm._v(" "),(_vm.action.channel == 'widget')?_c('b-tab',{attrs:{"title":"Widget"}},[_c('template-widget')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-325d79e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/action-templates/index.vue
// module id = null
// module chunks = 